// purpose: GPU削減を適用してよいiPhone／モバイル端末だけを一箇所で判定し、デスクトップ描画経路への混入を防ぐ。

export function isMobilePerformanceDevice(): boolean {
  if (typeof navigator === 'undefined' || typeof screen === 'undefined') return false;
  const userAgent = navigator.userAgent;
  if (/Android|iPhone|iPad|iPod|Mobile|IEMobile|Opera Mini/i.test(userAgent)) return true;
  // iPadOS can advertise itself as Macintosh in "desktop website" mode.
  return /Macintosh/.test(userAgent)
    && navigator.maxTouchPoints > 1
    && Math.min(screen.width, screen.height) <= 1024;
}
